var map = {
	"./191017 Hotspot tablet rules.png": "2d6b",
	"./App book Leap 30.9 swahili.png": "3cc7",
	"./App book Literacy 16.9.2019-min.png": "102a",
	"./App book Literacy.no.png": "338c",
	"./App book Numeracy.en.png": "4a48",
	"./App book Numeracy.no.png": "0fe7",
	"./App book.no.png": "05f1",
	"./FR - TASK book LITERACY-min.png": "6aa4",
	"./FR App book LLL 16.9.2019-min.png": "801b",
	"./Facilitator test Learning Lab - Fr.png": "322d",
	"./Facilitator test Learning Lab - SWAHILI.png": "86c9",
	"./Facilitator test Learning Lab.png": "6e71",
	"./Follow up the hotspots in the field 2.png": "f29e",
	"./Instruction Learning Hotspot Box.png": "92e2",
	"./Instruction Learning Hub Box - no speaker-with padlock.png": "1b3b",
	"./Leap Learning Hotspots user manual 15.01.2020.png": "cf5c",
	"./Leap Learning Lab - Guia de entrenamiento - 15.11.19.png": "2ce5",
	"./Leap Learning Lab MANUAL (NORSK) (10.12.19).png": "8790",
	"./Leap Learning Lab Training Guide - SWAHILI p1.png": "3271",
	"./Leap Learning Lab Training Guide - SWAHILI p2.png": "82df",
	"./Leap Learning Lab Training Guide Kenya Sept 2018  - FRENCH.png": "d299",
	"./Leap Learning Lab Training Guide.png": "dc03",
	"./Leap Learning Manuals.png": "d838",
	"./Leap Learning-WritingCastle.png": "c048",
	"./Leap Util Usage guide.png": "ca0f",
	"./Literacy Lab Station Overview.png": "3e60",
	"./NO task book NUMERACY.png": "eeeb",
	"./Numeracy Lab Station Overview.png": "88c8",
	"./Report - Leap Learning French.png": "f440",
	"./SW App book NUMERACY-min.png": "d67e",
	"./SW Task book NUMERACY-min.png": "6e77",
	"./TEMPLATE_Leap Learning report - hotspots.png": "f211",
	"./Task book Literacy.no.png": "7d46",
	"./Task book Literacy.png": "f143",
	"./Task book Numeracy.en.png": "e326",
	"./Task book swahili.png": "51dc",
	"./Training Guide Entrepreneurship lab 10.10_22-min.png": "738c",
	"./hotspot rules fr.png": "48c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "37b3";